var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "openlayers-wrapper",
    style: {
      height: _vm.tagShow ? "calc(100vh - 148px)" : "calc(100vh - 102px)"
    }
  }, [_c("open-map", {
    staticClass: "all-container"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };